import { useQuery } from '@tanstack/react-query';
import { getCategories } from '../api';

/**
 * Fetch complaint categories for the current brand (complaint form, etc.)
 * @param enabled - Whether to fetch (requires user + brand)
 * @param brandId - Brand context for cache key (refetches when brand changes)
 */
export function useCategories(enabled = true, brandId?: string | null) {
  return useQuery({
    queryKey: ['categories', brandId ?? ''],
    queryFn: async () => {
      const res = await getCategories();
      if (!res.status || !res.data) throw new Error('Failed to fetch categories');
      return res.data;
    },
    enabled: !!enabled,
  });
}
